import { render, staticRenderFns } from "./scan_action_description.vue?vue&type=template&id=0623d44e&scoped=true&"
import script from "./scan_action_description.vue?vue&type=script&lang=js&"
export * from "./scan_action_description.vue?vue&type=script&lang=js&"
import style0 from "./scan_action_description.vue?vue&type=style&index=0&id=0623d44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0623d44e",
  null
  
)

export default component.exports